import { ReportingTransactionsBack } from './types';

export abstract class IReportingHttpService {
  abstract getReportingPartners(
    country: string,
    startDate: string,
    endDate: string,
    theaterCode?: string,
  ): Promise<ReportingTransactionsBack>;
  abstract getReportingTransactions(
    country: string,
    startDate: string,
    endDate: string,
    theaterCode?: string,
  ): Promise<ReportingTransactionsBack>;
}
